// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';

import { createLabelingRunAsync } from 'actions/labeling-runs-actions';

interface Props {
    visible: boolean;
    onClose: () => void;
}

export default function CreateRunModal({ visible, onClose }: Props): JSX.Element {
    const dispatch = useDispatch();
    const history = useHistory();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    const handleOk = async (): Promise<void> => {
        if (!name.trim()) return;
        setLoading(true);
        try {
            const run = await dispatch(createLabelingRunAsync(name.trim()) as any);
            setName('');
            onClose();
            history.push(`/labeling-runs/${run.id}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title='Create Labeling Run'
            visible={visible}
            onOk={handleOk}
            onCancel={() => { setName(''); onClose(); }}
            okText='Create'
            confirmLoading={loading}
        >
            <Input
                placeholder='Run name'
                value={name}
                onChange={(e) => setName(e.target.value)}
                onPressEnter={handleOk}
            />
        </Modal>
    );
}
